import { render, staticRenderFns } from "./MixologiaRed.vue?vue&type=template&id=ebcf1030&scoped=true&"
import script from "./MixologiaRed.vue?vue&type=script&lang=js&"
export * from "./MixologiaRed.vue?vue&type=script&lang=js&"
import style0 from "./MixologiaRed.vue?vue&type=style&index=0&id=ebcf1030&scoped=true&lang=scss&"
import style1 from "./MixologiaRed.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcf1030",
  null
  
)

export default component.exports